import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22_app.tsx%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:%22../fonts/bonk-vf.ttf%22,%22weight%22:%22100%20900%22,%22display%22:%22swap%22,%22fallback%22:[%22ui-sans-serif%22,%22system-ui%22,%22sans-serif%22]}],%22variableName%22:%22heading%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'heading', 'heading Fallback', ui-sans-serif, system-ui, sans-serif",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
